import axios from "utils/axios";

export const setupClearData = () => {
  return axios.post(`/hr/setup/clearData`);
};
